<template>
  <v-app class="app">
    <div class="toolbar-wrapper">
      <v-toolbar class="toolbar" flat height="150px">
        <!-- {{ isWindowWide }}
        {{ windowWidth }} -->
        <div class="toolbar-content">
          <!-- Left-aligned "GLXY_SIMS" -->
          <div class="nav-title-container">
            <router-link to="/" class="nav-title">GLXY_SIMS</router-link>
            <!-- Tagline below GLXY_SIMS -->
            <div class="tagline">ELEGANCE | LUXURY | SIMPLICITY</div>
          </div>

          <!-- Center-aligned "GLXY_GETAWAY" -->
          <router-link to="/getaway" class="center-link" v-if="isWindowWide">
            GLXY_GETAWAY
          </router-link>

          <!-- Right-aligned "MODS" -->
          <router-link to="/tree" class="right-link" v-if="isWindowWide"
            >GLXY_TREE</router-link
          >
        </div>
      </v-toolbar>
      <!-- Row of Centered Rounded Buttons Below Title -->

      <div
        v-if="isWindowWide"
        :class="['button-container', { hidden: !showButtons }]"
      >
        <div class="button-row">
          <v-btn
            class="rounded-btn"
            href="https://www.reddit.com/user/Glxy_sims/"
            target="_blank"
          >
            <font-awesome-icon :icon="['fab', 'reddit']" class="white-icon" />
          </v-btn>

          <v-btn
            class="rounded-btn"
            href="https://www.youtube.com/@glxy_sims"
            target="_blank"
          >
            <font-awesome-icon :icon="['fab', 'youtube']" class="white-icon" />
          </v-btn>

          <v-btn
            class="rounded-btn"
            href="https://www.tiktok.com/@glxy_sims"
            target="_blank"
          >
            <font-awesome-icon :icon="['fab', 'tiktok']" class="white-icon" />
          </v-btn>

          <v-btn
            class="rounded-btn"
            href="https://ie.pinterest.com/glxy_sims/"
            target="_blank"
          >
            <font-awesome-icon
              :icon="['fab', 'pinterest']"
              class="white-icon"
            />
          </v-btn>

          <v-btn
            class="rounded-btn"
            href="https://www.ea.com/en-gb/games/the-sims/the-sims-4/pc/gallery"
            target="_blank"
          >
            <div class="custom-icon">
              <img :src="require('@/assets/the-sims.svg')" alt="Gallery" />
            </div>
          </v-btn>
        </div>
      </div>

      <div
        v-if="!isWindowWide"
        :class="['button-container', { hidden: !showButtons }]"
      >
        <!-- Social Media Buttons (Fly Out Left, Fly Back Right) -->
        <div :class="['button-row', showSocials ? 'fly-back' : 'fly']">
          <v-btn
            class="rounded-btn"
            href="https://www.reddit.com/user/Glxy_sims/"
            target="_blank"
          >
            <font-awesome-icon :icon="['fab', 'reddit']" class="white-icon" />
          </v-btn>

          <v-btn
            class="rounded-btn"
            href="https://www.youtube.com/@glxy_sims"
            target="_blank"
          >
            <font-awesome-icon :icon="['fab', 'youtube']" class="white-icon" />
          </v-btn>

          <v-btn
            class="rounded-btn"
            href="https://www.tiktok.com/@glxy_sims"
            target="_blank"
          >
            <font-awesome-icon :icon="['fab', 'tiktok']" class="white-icon" />
          </v-btn>

          <v-btn
            class="rounded-btn"
            href="https://ie.pinterest.com/glxy_sims/"
            target="_blank"
          >
            <font-awesome-icon
              :icon="['fab', 'pinterest']"
              class="white-icon"
            />
          </v-btn>

          <v-btn
            class="rounded-btn"
            href="https://www.ea.com/en-gb/games/the-sims/the-sims-4/pc/gallery"
            target="_blank"
          >
            <div class="custom-icon">
              <img :src="require('@/assets/the-sims.svg')" alt="Gallery" />
            </div>
          </v-btn>
        </div>

        <!-- Placeholder Buttons (Fly In Right, Fly Back Left) -->
        <div
          v-if="!showSocials"
          :class="['new-button-row', showSocials ? 'fly-out' : 'fly-in']"
        >
          <router-link to="/getaway" class="white-text-btn">
            GLXY_GETAWAY
          </router-link>

          <!-- Right-aligned "MODS" -->
          <router-link to="/tree" class="white-text-btn">GLXY_TREE</router-link>
        </div>

        <div class="burger-menu" v-if="!isWindowWide">
          <XMenuIcon @checkbox-changed="handleCheckboxChange" />
        </div>
      </div>
    </div>

    <!-- Main content starts below toolbar and button row -->
    <div class="main-content">
      <AnimatedRouterView />
    </div>
    <v-footer class="custom-footer">
      <!-- Footer Header: Title and Tagline -->
      <div class="footer-header">
        <span @click="goToHomePage" class="footer-header-title">GLXY_SIMS</span>
        <div class="footer-header-tagline">ELEGANCE | LUXURY | SIMPLICITY</div>
      </div>

      <!-- Footer Bottom: Copyright and Rights Reserved -->
      <div class="footer-bottom">
        <div class="footer-text">
          <a>&copy; 2026</a>
          <a
            href="https://www.youtube.com/@glxy_sims"
            target="_blank"
            class="footer-link"
          >
            Glxy_sims All Rights Reserved.
          </a>
          <div>
            <a>
              This site is in no way affiliated or endorsed by EA (Electronic
              Arts).
            </a>
          </div>
        </div>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import XMenuIcon from "./icons/XMenuIcon.vue";
import { WS } from "@/services/WS";
import AnimatedRouterView from "./components/AnimatedRouterView.vue";

export default {
  name: "App",
  components: { XMenuIcon, AnimatedRouterView },
  data() {
    return {
      showButtons: true, // Control visibility of button-row
      isWindowWide: window.innerWidth > 924,
      windowWidth: window.innerWidth,
      showSocials: true,
    };
  },
  methods: {
    handleScroll() {
      this.showButtons = window.scrollY < 30; // Hide buttons after scrolling 50px
    },
    handleResize() {
      this.isWindowWide = window.innerWidth > 924;
      this.windowWidth = window.innerWidth;
    },
    swooshButtons() {
      this.showSocials = !this.showSocials;
    },
    handleCheckboxChange(isChecked) {
      this.showSocials = !isChecked;
    },
    goToHomePage() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, 300);
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    WS.recordUsage();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
